import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowLeft, TickCircle } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { SefanoButton } from "@/components/Molecules";
import { SettingsInstagramPanel } from "@/components/Organisms";
import { PageTemplate } from "@/components/Templates/Page";
import type { InstagramOnboardingTemplateProps } from "./InstagramOnboarding.template.types";
import * as styles from "./InstagramOnboarding.template.styles";

export type { InstagramOnboardingTemplateProps } from "./InstagramOnboarding.template.types";

export function InstagramOnboardingTemplate({
  storeName,
  isConnected,
  connection,
  onSkip,
}: InstagramOnboardingTemplateProps) {
  const { t } = useTranslation("instagram");
  const theme = useTheme();

  const panel = <SettingsInstagramPanel variant="page" {...connection} />;

  return (
    <PageTemplate maxWidth={1100}>
      <Box sx={styles.stack}>
        <Box sx={styles.heading}>
          <Box component="span" sx={styles.successBadge}>
            <TickCircle size={16} variant="Bold" color={theme.palette.success.main} />
            {t("onboarding.badge")}
          </Box>
          <Typography component="h1" sx={styles.title}>
            {isConnected ? t("onboarding.connectedTitle") : t("onboarding.title", { name: storeName })}
          </Typography>
          <Typography sx={styles.subtitle}>
            {isConnected ? t("onboarding.connectedSubtitle") : t("onboarding.subtitle")}
          </Typography>
        </Box>

        {isConnected ? <Box sx={styles.connectedCard}>{panel}</Box> : panel}

        <Box sx={styles.footer}>
          {isConnected ? (
            <SefanoButton
              onClick={onSkip}
              endIcon={<ArrowLeft size={18} variant="Linear" color={theme.palette.common.white} />}
              sx={styles.primaryButton}
            >
              {t("onboarding.goDashboard")}
            </SefanoButton>
          ) : (
            <>
              <Button variant="text" onClick={onSkip} sx={styles.skipButton}>
                {t("onboarding.skip")}
              </Button>
              <Typography sx={styles.laterHint}>{t("onboarding.laterHint")}</Typography>
            </>
          )}
        </Box>
      </Box>
    </PageTemplate>
  );
}
